var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"bbeDropArea",staticClass:"bbe-drop-files",class:{'bbe-drop-files_show': _vm.visibility && !_vm.draggedTemplate.start}},[_c('i',{staticClass:"email-icon-up-arrow bbe-drop-files__icon"}),_vm._v(" "),_c('span',{staticClass:"bbe-drop-files__text"},[_vm._v("\n      Drop your files and upload\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b3c88f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/DropFiles/DropFiles.vue
// module id = null
// module chunks = 